enum ContractUserDialogMode {
  CREATE,
  DETAIL,
  EDIT
}

export default ContractUserDialogMode;